import React from "react";
import {Link} from "react-router-dom";
import {ListItem} from "@deere/ux.uxframe-react";
import {Box, Grid, Typography} from '@deere/fuel-react';
import WarningIcon from '@material-ui/icons/Warning';
import DoneIcon from '@material-ui/icons/Done';

export const Feedback = ({feedback}) => {
    const requestedName = feedback.requestedById ? `${feedback.requestedByName} - ${feedback.requestedById}` : "";
    return (
        <ListItem className="list-group-item mb-1" style={{borderRadius: "0.25rem"}} key={feedback.campaignId}>
            <Grid container>
                <Grid item xs={12} md={8}>
                    {feedback.responseStatus.id === 3 && (
                        <>
                            {feedback.campaignTitle}
                        </>
                    )}
                    {feedback.responseStatus.id === 2 &&(
                        <Link
                            to={{
                                pathname: `/feedback/view-feedback/${feedback.campaignId}`,
                            }}>
                            {feedback.campaignTitle}
                        </Link>
                    )}
                    {feedback.responseStatus.id === 1 &&(
                        <Link
                            to={{
                                pathname: `/feedback/submit-feedback/${feedback.campaignId}`,
                            }}>
                            {feedback.campaignTitle}
                        </Link>
                    )}
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            Response Status &nbsp;
                        </Typography>
                        {feedback.responseStatus.id === 1 && (
                            <WarningIcon fontSize="small" style={{fill: "#fab64c", marginRight: "0.25rem"}} display="inline"/>)}
                        {feedback.responseStatus.id === 2 && (
                            <DoneIcon fontSize="small" style={{fill: "#367c2b"}} display="inline"/>)}
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {feedback.responseStatus.description}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Typography size="md" fontWeight="bold" component="p" display="inline">
                        Requested By &nbsp;
                    </Typography>
                    <Typography size="md" fontWeight="regular" component="p" display="inline">
                        {requestedName}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            Due Date &nbsp;
                        </Typography>
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {feedback.dueDate}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </ListItem>
    );
}